// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__QzytC","icon":"styles_icon__8DIFJ"};